// eslint-disable-next-line import/prefer-default-export
export enum POSITION {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
  BOTTOM = 'BOTTOM',
  TOP = 'TOP',
}
